import baseUserContextComponent from "@/components/baseUserContextComponent";
import { CustomerInfoModel } from "@/models/customerModels";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class checkoutLayout extends baseUserContextComponent {

}
